<script setup lang="ts">
import type { EntryInterfaceTypeFragment } from '#graphql-operations'

interface ArchiveFiltersProps {
  filtersList: Partial<EntryInterfaceTypeFragment>[]
}

defineProps<ArchiveFiltersProps>()

const filters = defineModel<string[]>({
  default: () => [],
})

const isLargeScreen = useMq('lg')
const { close } = useMagicDrawer('filters-drawer')

watch(isLargeScreen, (isLarge, prevIsLarge) => {
  if (isLarge !== prevIsLarge) {
    if (isLarge) {
      close()
    }
  }
})
</script>

<template>
  <aside class="archiveFilters my-10 lg:my-15">
    <template v-if="(filtersList?.length || 0) > 1">
      <div class="container flex flex-col space-y-5">
        <Text class="typo-sans-1 text-center uppercase" :text="$t('topics')" />
        <div
          role="group"
          :aria-label="$t('topics')"
          class="hidden lg:flex lg:flex-wrap lg:gap-1 lg:justify-center"
        >
          <FilterChip
            v-for="filter in filtersList"
            :key="filter?.slug"
            v-model="filters"
            :value="filter.slug || ''"
            :label="filter.title || ''"
            type="checkbox"
          />
        </div>
        <div class="desktop-only text-center min-h-6">
          <ButtonLink
            v-show="filters.length > 0"
            :title="$t('reset')"
            @click="filters = []"
          />
        </div>
      </div>
      <MagicDrawerProvider
        id="filters-drawer"
        :options="{
          position: 'bottom',
        }"
      >
        <div class="text-center lg:hidden">
          <MagicDrawerTrigger as-child>
            <Button theme="primary" :title="$t('filters')" />
          </MagicDrawerTrigger>
        </div>
        <MagicDrawerTeleport>
          <div class="archiveFiltersDrawer">
            <MagicDrawerBackdrop />
            <MagicDrawerContent>
              <div class="rounded bg-white/90 size-full backdrop-blur-6px">
                <div class="container py-5 flex flex-col h-full">
                  <div class="flex items-center justify-end">
                    <!-- <ButtonLink :title="$t('close')" @click="close" /> -->
                    <ButtonIcon :aria-label="$t('close')" icon="close" @click="close" />
                  </div>
                  <div class="mt-4 flex flex-wrap gap-2 justify-center">
                    <FilterChip
                      v-for="filter in filtersList"
                      :key="filter?.slug"
                      v-model="filters"
                      :value="filter.slug || ''"
                      :label="filter.title || ''"
                      type="checkbox"
                    />
                  </div>
                  <ul class="mt-auto flex flex-col gap-1 items-center">
                    <li>
                      <Button theme="primary" :title="$t('show_results')" @click="close" />
                    </li>
                    <li>
                      <ButtonLink :title="$t('clear_filters')" @click="filters = []" />
                    </li>
                  </ul>
                </div>
              </div>
            </MagicDrawerContent>
          </div>
        </MagicDrawerTeleport>
      </MagicDrawerProvider>
    </template>
  </aside>
</template>

<style>
.archiveFiltersDrawer {
  --magic-drawer-height: 45svh;
  --magic-drawer-drag-overshoot-x: 0;
  --magic-drawer-z-index: 11;
}
</style>
